import { render, staticRenderFns } from "./ThemeSettings.vue?vue&type=template&id=1ed065c2&scoped=true&"
import script from "./ThemeSettings.vue?vue&type=script&lang=js&"
export * from "./ThemeSettings.vue?vue&type=script&lang=js&"
import style0 from "./ThemeSettings.vue?vue&type=style&index=0&id=1ed065c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed065c2",
  null
  
)

export default component.exports